function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import isRegularClick from "../utils/isRegularClick";
import parseArgs from "../utils/parseArgs";
import toggleClass from "../utils/toggleClass";
export var key = 'trimmingsToggle';
export var eventNames = ['click', 'input', 'change'];
export var handle = function handle(e) {
  var element = e.target;

  var _parseArgs$args = _slicedToArray(parseArgs(element.dataset.trimmingsToggle).args, 2),
      targetSelector = _parseArgs$args[0],
      className = _parseArgs$args[1];

  var target = document.querySelector(targetSelector);

  if (!target) {
    return;
  }

  var state = null;

  if (element.nodeName === 'BUTTON') {
    if (e.type === 'click' && !isRegularClick(e)) {
      return;
    }

    state = !target.classList.contains(className);
  } else if (element.nodeName === 'INPUT') {
    var type = element.getAttribute('type');

    if (['radio', 'checkbox'].includes(type)) {
      state = element.checked;

      if (type === 'radio') {
        if (element.dataset.trimmingsChainToggle === 'true') {
          element.dataset.trimmingsChainToggle = null;
        } else {
          var name = element.getAttribute('name');
          var radios = document.querySelectorAll("input[type=\"radio\"][name=\"".concat(name, "\"]"));
          Array.prototype.forEach.call(radios, function (radio) {
            if (radio === element) {
              return;
            }

            radio.dataset.trimmingsChainToggle = 'true';
            radio.dispatchEvent(new window.Event('change', {
              bubbles: true
            }), true);
          });
        }
      }
    } else {
      state = (element.value || '').toString().length > 0;
    }
  }

  toggleClass(target, className, state);
};